import { PostFinanceAccountsApi } from "@/features/accounts/finance/services/post-accounts-api";
import { PostFinanceAccountsRequestModel } from "@/features/accounts/finance/services/post-accounts-model";

/// 銀行口座登録処理
export class PostFinanceAccountsService {
  private postFinanceAccountsApi = new PostFinanceAccountsApi();

  /**
   * 銀行口座登録API実行
   */
  public async postFinanceAccounts(param: PostFinanceAccountsRequestModel) {
    return await this.postFinanceAccountsApi.postFinanceAccounts(param);
  }
}
